module.exports = __webpack_public_path__ + "img/taoambro.93b2def6.jpg";